<template>
  <div :class="collapsed ? '' : 'logo-image-holder'">
    <v-img
      v-if="isBrosnan"
      @click="toggle()"
      :src="brosnanSrc"
      height="100%"
      width="100%"
      contain
      alt="hyperion logo"
      class="hyp-logo"
      :class="collapsed ? 'brosnan-collapse-adjust' : ''"
    ></v-img>

    <v-img
      v-if="!useSvg && !isBrosnan"
      @click="toggle()"
      :src="src"
      :height="height"
      :width="width"
      contain
      alt="hyperion logo"
      class="hyp-logo"
      ><span v-if="deployEnvStage" class="hyp-logo-test"
        >{{ deployEnvStage }} ENV</span
      ></v-img
    >

    <svg
      v-if="useSvg && !isBrosnan"
      style="cursor: pointer;"
      @click="toggle()"
      width="41px"
      height="41px"
      viewBox="0 0 41 41"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <g
        id="MainView"
        stroke="none"
        stroke-width="1.75"
        fill="none"
        fill-rule="evenodd"
        shape-rendering="geometricPrecision"
      >
        <g transform="translate(-30.000000, -16.000000)" id="Group">
          <g transform="translate(31.000000, 17.000000)">
            <g id="Group-2" transform="translate(11.550000, 8.050000)">
              <text
                id="H"
                font-family="Archivo-Regular, Archivo-Light"
                font-size="20"
                font-weight="normal"
                fill="#070707"
              >
                <tspan x="0" y="20">H</tspan>
              </text>
              <path
                d="M1.80627686,1.71093262 L13.45,1.71093262"
                id="Path"
                stroke="#070707"
                stroke-width="2.45"
              ></path>
            </g>
            <rect
              id="Rectangle"
              stroke="#000000"
              x="0.5"
              y="0.5"
              width="37.5"
              height="37.15"
              rx="18.575"
            ></rect>
          </g>
        </g>
      </g>
    </svg>
  </div>
</template>

<script>
import { hasGroupByName } from "@/services/user/user.service";
import { DEPLOY_ENV } from "@/common/config";

const EMITTED_ACTIONS = {
  CLICK: "click",
};

export default {
  name: "Logo",
  props: {
    type: {
      type: String,
      validator: function (value) {
        return (
          [
            "black-on-white",
            "white-on-black",
            "white-bg",
            "svg",
            "black-on-white-144",
          ].indexOf(value) !== -1
        );
      },
      default: "white-on-black",
    },
    width: {
      type: Number,
      default: 39,
    },
    height: {
      type: Number,
      default: 39,
    },
    disableToggle: {
      type: Boolean,
    },
    collapsed: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isBrosnan() {
      return hasGroupByName("User_Brosnan_Risk_Consultants");
    },
    brosnanSrc() {
      return require("@/assets/images/BrosnanLogo.png");
    },
    src() {
      return require(`@/assets/images/seerist_logo.png`);
    },
    useSvg() {
      return this.type === "svg";
    },
    deployEnvStage() {
      if (
        DEPLOY_ENV.toLowerCase() === "test" ||
        DEPLOY_ENV.toLowerCase() === "development"
      ) {
        return DEPLOY_ENV.length > 4
          ? DEPLOY_ENV.toUpperCase().substring(0, 3)
          : DEPLOY_ENV.toUpperCase();
      }
      return false;
    },
  },
  methods: {
    toggle() {
      if (!this.disableToggle) {
        this.$emit(EMITTED_ACTIONS.CLICK);
      }
    },
  },
};
</script>

<style scoped>
.logo-image-holder {
  padding-top: 20px;
  padding-bottom: 10px;
}
.hyp-logo {
  margin: auto;
  cursor: pointer;
}
.hyp-logo-test {
  display: block;
  width: 100%;
  text-align: center;
  font-weight: bold;
  color: #bf2500;
  margin-top: -5px;
}
.brosnan-collapse-adjust {
  margin-left: 14px;
  padding-top: 5px;
  top: -20px;
}
</style>
